import { formValueSelector } from 'redux-form'
import { PROMOTION_LIGHT_BOX_FORM } from './constants'

export const formSelector = formValueSelector(PROMOTION_LIGHT_BOX_FORM)

export const getPromotions = ({
  promotionsLightBox: {
    lightBoxPromotionVo: {
      activePromotions = [],
      availablePromotions = []
    } = {}
  } = {}
}) => ({ activePromotions, availablePromotions })
